/**
 * Lightweight client funnel counters (K-factor / soft-launch metrics).
 * Persists locally; optionally beacons to the Worker for server logs.
 */

const STORAGE_KEY = 'vq_analytics_v1';
const MAX_EVENTS = 120;

function load() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return { counts: {}, events: [] };
        const parsed = JSON.parse(raw);
        return {
            counts: parsed.counts && typeof parsed.counts === 'object' ? parsed.counts : {},
            events: Array.isArray(parsed.events) ? parsed.events : [],
        };
    } catch {
        return { counts: {}, events: [] };
    }
}

function save(store) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch {
        /* quota / private mode */
    }
}

/**
 * @param {string} name
 * @param {Record<string, string|number|boolean|null|undefined>} [props]
 */
export function trackEvent(name, props = {}) {
    if (!name) return;
    const store = load();
    store.counts[name] = (store.counts[name] || 0) + 1;
    store.events.push({
        t: Date.now(),
        name,
        ...props,
    });
    if (store.events.length > MAX_EVENTS) {
        store.events = store.events.slice(-MAX_EVENTS);
    }
    save(store);

    try {
        const base = typeof window !== 'undefined' ? '' : '';
        const url = `${base}/api/game/analytics`;
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name, props, t: Date.now() }),
            keepalive: true,
        }).catch(() => {});
    } catch {
        /* offline / mock */
    }
}

export function trackShare(result, context = {}) {
    trackEvent('share_invite', {
        result: result || 'unknown',
        ...context,
    });
}

export function getAnalyticsSnapshot() {
    return load();
}

export function getShareClickCount() {
    return load().counts.share_invite || 0;
}
